import React from 'react';
import styled from 'styled-components';
import {fontSize, CTAButton} from '../../mixins';


const StyledList = styled.div`
  width: 100%;
  
  ul {
      list-style: none;
      padding-left: 16px;
      text-align: left;
      ${fontSize(13)};
      line-height: 16px;
      margin: 7px 0 0 0;
  }
  
  li {
    margin-bottom: 10px;

        &::before {
            content: "\\2022";
            color: #00bfa5;
            font-weight: 700;
            display: inline-block;
            width: 1em;
            margin-left: -1em;
        }
  }
  
  a {
    ${CTAButton};
  }
`




const FeaturesList = () => (
    <StyledList>
        <ul>
            <li>Track and share location privately</li>
            <li>Get car crash alerts and driver coaching</li>
            <li>Add a GPS Tracker device to your family map</li>
        </ul>
        <a href='https://onboarding.geozilla.com/discount'>Start Free Trial</a>
    </StyledList>
);


export default FeaturesList;